import { Heading } from "./..";
import React from "react";
import { Link } from "react-router-dom";

export default function NavbarItem({ isLink = false, section, title, link }) {
  const scrollToSection = (ref) => {
    section.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {!isLink ? (
        <li onClick={scrollToSection} className="cursor-pointer">
          <Heading
            size="headingxs"
            as="h5"
            className="!font-lora text-[1.1vw] md:text-[16px] font-semibold hover:text-[#E96D4C]"
          >
            {title}
          </Heading>
        </li>
      ) : (
        <li className="cursor-pointer">
          <Link to={link}>
            <Heading
              size="headingxs"
              as="h5"
              className="!font-lora text-[1.1vw] md:text-[16px] font-semibold hover:text-[#E96D4C]"
            >
              {title}
            </Heading>
          </Link>
        </li>
      )}
    </>
  );
}
